import { useEffect, useState } from 'react';

import { defineMessage } from '@lingui/macro';

import {
  DATE_SEPARATOR_FRONTEND,
  autoHandleDateSlash,
  inputDateToIsoDate,
  isMonthFirstDateFormat,
  isoDateToInputDate,
  isValidPastDate,
  toIsoDate,
} from '../../../utils/dateUtil';
import InputText from './InputText';

export const BIRTHDATE_FIELDNAME = 'birthdate';

const InputBirthDate = ({ fieldValue, onChange, className, ...props }) => {
  const [inputDate, setInputDate] = useState(() => isoDateToInputDate(fieldValue));
  const [isInvalidDate, setInvalidDate] = useState(false);

  useEffect(() => {
    if (inputDateToIsoDate(inputDate) !== (toIsoDate(fieldValue) ?? '')) {
      setInputDate(isoDateToInputDate(fieldValue));
    }
  }, [fieldValue]);

  const handleDateChange = (fName, fieldValue) => {
    const formattedDate = autoHandleDateSlash(fieldValue);
    const isValidDate = isValidPastDate(formattedDate);
    // if (isValidDate !== null && !isValidDate) {
    //   console.log('invalid date', fieldValue, 'vs', formattedDate);
    // }
    setInvalidDate(isValidDate !== null && !isValidDate);

    setInputDate(formattedDate);
    onChange(fName, inputDateToIsoDate(formattedDate));
  };

  return (
    <InputText
      fieldLabel={defineMessage({ message: 'Birthdate' })}
      fieldPlaceholder={isMonthFirstDateFormat() ? monthFirstPlaceholder : dayFirstPlaceholder}
      fieldValue={inputDate}
      className={className ? className + ' inputDate' : 'inputDate'}
      onChange={handleDateChange}
      pattern={'\\d{1,2}' + DATE_SEPARATOR_FRONTEND + '\\d{1,2}' + DATE_SEPARATOR_FRONTEND + '\\d{4}'}
      inputCustomStyle={{ wordSpacing: '-3px' }}
      isInvalid={isInvalidDate}
      {...props}
    />
  );
};

export default InputBirthDate;

const dayFirstPlaceholder = defineMessage({ message: 'dd/mm/yyyy' });
const monthFirstPlaceholder = defineMessage({ message: 'mm/dd/yyyy' });
